import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";

function UpdatePageContent() {
  const editor = useRef(null);
  const navigate = useNavigate();
  const { srno } = useParams();
  const [formData, setFormData] = useState({
    contentid: "",
    contentname: "",
    contenttitle: "",
    content: "",
    contenttype: "",
    pageid: "",
    pagelocationid: "",
  });

  const [allPageContent, setAllPageContent] = useState([]);
  const callApiPageContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + "pagecontent/showall";
      const response = await axios.get(url, { headers });
      setAllPageContent(response.data);
    } catch (error) {
      toast.error("Couldn't Fetch Page", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };
  useEffect(() => {
    if (allPageContent.length === 0) {
      callApiPageContent();
    }
    const matchingPageContent = allPageContent.find(
      (item) => item.srno === parseInt(srno, 10)
    );
    if (matchingPageContent) {
      setFormData(matchingPageContent);
    }
  }, [srno, allPageContent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleContentChange = (newContent) => {
    setFormData({ ...formData, content: newContent });
  };

  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const callApiUpdateContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      }
      const url = process.env.REACT_APP_API_URL + "pagecontent/updates/" + srno;
      await axios.put(url, formData, { headers });
    } catch (err) {
      toast.error("Post not updated", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setShowUpdateModal(false)
    if (
      !formData.contentid ||
      !formData.contentname ||
      !formData.contenttitle ||
      !formData.content ||
      !formData.contenttype ||
      !formData.pageid ||
      !formData.pagelocationid
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    } else {
      try {
        await callApiUpdateContent();
        toast.success("PageContent Updated Successfully", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      } catch (error) {
        toast.error("PageContent not updated", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      }
      setTimeout(() => {
        navigate("/pagecontentlist");
      }, 2000);
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setShowUpdateModal(true)
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Page Content
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Sr No & Content ID */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="srno">
                  <Form.Label>Sr No:</Form.Label>
                  <Form.Control
                    type="number"
                    name="srno"
                    value={formData.srno}
                    readOnly
                    placeholder="srno"
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="contentid">
                  <Form.Label>PageContent Id:</Form.Label>
                  <Form.Control
                    type="text"
                    name="contentid"
                    value={formData.contentid}
                    onChange={handleChange}
                    placeholder="PageContent"
                    maxLength={50}
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Content Name & Content Title */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="contentname">
                  <Form.Label>PageContent Name:</Form.Label>
                  <Form.Control
                    type="text"
                    name="contentname"
                    value={formData.contentname}
                    onChange={handleChange}
                    placeholder="PageContent Name"
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="contenttitle">
                  <Form.Label>PageContent Title:</Form.Label>
                  <Form.Control
                    type="text"
                    name="contenttitle"
                    value={formData.contenttitle}
                    onChange={handleChange}
                    placeholder="PageContent Title"
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              {/* Page Content (JoditEditor) */}
              <Form.Group className="mb-3" controlId="content">
                <Form.Label>PageContent:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={formData.content}
                  id="content"
                  className="form-control"
                  name="content"
                  onChange={handleContentChange}
                />
              </Form.Group>

              {/* Row 3: Content Type & Page Id */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="contenttype">
                  <Form.Label>PageContent Type:</Form.Label>
                  <Form.Control
                    type="text"
                    name="contenttype"
                    value={formData.contenttype}
                    onChange={handleChange}
                    placeholder="PageContent Type"
                    maxLength={20}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="pageid">
                  <Form.Label>PageContent Id:</Form.Label>
                  <Form.Control
                    type="number"
                    name="pageid"
                    value={formData.pageid}
                    onChange={handleChange}
                    placeholder="PageContent Id"
                  />
                </Form.Group>
              </Row>

              {/* Page Location Id */}
              <Row className="mb-3">
                <Form.Group as={Col} md={6} controlId="pagelocationid">
                  <Form.Label>PageContent Location Id:</Form.Label>
                  <Form.Control
                    type="number"
                    name="pagelocationid"
                    value={formData.pagelocationid}
                    onChange={handleChange}
                    placeholder="PageContent Location Id"
                  />
                </Form.Group>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Page Content
                </button>
                <Link to="/pagecontentlist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <ToastContainer />

      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Page Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sure you want to update page?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUpdateModal(false)}>
            Cancel
          </Button>
          <Button type="button" onClick={handleUpdate} variant="primary" style={{ marginLeft: '10px' }}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdatePageContent;
